import { t } from "../../validation/validator";

export const stripeBillingDetailsSchema = t.type({
  name: t.string,
  address: t.type({
    line1: t.string,
    line2: t.union([t.string, t.null]),
    city: t.string,
    state: t.string,
    postal_code: t.string,
    country: t.string,
  }),
});

export const stripeBillingDetailsRequestSchema = t.intersection([
  t.type({ account_id: t.number }),
  t.partial({ billing_details: stripeBillingDetailsSchema }),
]);
export type StripeBillingDetails = t.TypeOf<typeof stripeBillingDetailsSchema>;
